"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequiredKey = void 0;
var React = require("react");
var __1 = require("..");
var Localization_1 = require("../../Localization");
var RequiredKey_styles_1 = require("./RequiredKey.styles");
var RequiredKey = function () { return (React.createElement(RequiredKey_styles_1.FormKey, { "aria-hidden": true },
    React.createElement(__1.TextWithRequired, { LabelText: Localization_1.strings.Form_Message_RequiredKey, ShowRequiredIndicator: true }))); };
exports.RequiredKey = RequiredKey;
